import { render, staticRenderFns } from "./BlogSearch.vue?vue&type=template&id=2f69bdbc&"
import script from "./BlogSearch.vue?vue&type=script&lang=js&"
export * from "./BlogSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports